<template>
  <div id="app">
<!--     <div id="nav">
      <router-link :to="{ name: 'Home'}">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <!-- <masternav/> -->
    <!-- <LocaleSwitcher />
    <MainMenu /> -->
    <router-view/>
  </div>
</template>
<script>
import LocaleSwitcher from '@/components/LocaleSwitcher.vue'
import MainMenu from '@/components/MainMenu.vue'
import masternav from '@/components/masternav.vue'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  title: 'Enterprise Panamá',
  components: {
    LocaleSwitcher,
    MainMenu,
    masternav
  },
  methods: {
    ...mapActions(['getcitiesList'])
  }
}
</script>
<style lang="scss">
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
} */

/*calendario* */
.b-calendar{
    position: absolute;
    z-index: 1;
    background-color: #169A5A;
    .b-calendar-grid{
      background-color: #ffffff;
      color:rgb(0, 0, 0);
   
    }
    footer{
      visibility: hidden;
    }
}

</style>
